import _ from 'lodash'

import { getMatrixCoordinateId, isFilledArray } from './helpers'

const formAnswersHelpers = (answers) => {
  function getAnswer(question) {
    return answers?.find((a) => a.question === question.id)
  }

  function getAnswers(question) {
    return answers?.filter((a) => a.question === question.id)
  }

  function getAnswerSignature(question) {
    return answers?.find((a) => a.question === question.id)
  }

  function getAnswerCell(row, column, page_id) {
    if (page_id) {
      const answer = answers
        ?.find((a) => a.original_page_id === page_id)
        ?.answers?.find(
          (a) =>
            getMatrixCoordinateId(a.question_column) === column &&
            getMatrixCoordinateId(
              a.question_row ?? a?.answer_matrix_other_row
            ) === row
        )
      return answer
    }
    return answers?.find(
      (a) =>
        getMatrixCoordinateId(a.question_column) === column &&
        getMatrixCoordinateId(a.question_row ?? a?.answer_matrix_other_row) ===
          row
    )
  }

  function getTableQuestionExtraRows(question) {
    const questionExtraRows = []
    if (!isFilledArray(answers)) return []
    // in case of not submitted responses
    if (_.some(answers, (answer) => !_.isNil(answer?.willRemove))) {
      answers.forEach((answer) => {
        if (
          question.id === answer.questionId &&
          answer?.willRemove !== true &&
          _.every(
            question?.question_rows,
            ({ id }) => id !== answer.question_row
          ) &&
          _.every(questionExtraRows, ({ id }) => id !== answer.question_row)
        ) {
          questionExtraRows.push({
            id: answer.question_row,
            order: answer.question_row,
            question: answer.questionId,
            response: answer.text_value,
            text: null,
          })
        }
      })
      return questionExtraRows
    }
    answers.forEach((answer) => {
      if (
        !_.isNil(answer?.answer_matrix_other_row) &&
        !_.isNil(answer?.question_column) &&
        question.id === answer.question &&
        _.every(
          questionExtraRows,
          ({ id }) => id !== answer?.answer_matrix_other_row?.id
        )
      ) {
        questionExtraRows.push(answer.answer_matrix_other_row)
      }
    })
    return questionExtraRows
  }

  return {
    getAnswer,
    getAnswers,
    getAnswerSignature,
    getAnswerCell,
    getTableQuestionExtraRows,
  }
}

export default formAnswersHelpers
